import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface FormsConfig {
    defaultImagesAvailable: number;
    defaultThumbnailColor: string;
    formsApiPath: string;
    formsCdnPath: string;
    formsMsaTenantId: string;
    formsThemingConfigUrl: string;
    formsThumbnailImagesUrl: string;
    neoPortalPageEnabled: boolean;
    groupPhotoRequestInBatch: boolean;
    termsOfServiceLinkOrgId: string;
}

@Injectable({
    providedIn: 'root'
})
export class FormsConfigService {
    public readonly config: FormsConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<FormsConfig>('formsConfig') || {
            defaultImagesAvailable: null,
            defaultThumbnailColor: null,
            formsApiPath: null,
            formsCdnPath: null,
            formsMsaTenantId: null,
            formsThemingConfigUrl: null,
            formsThumbnailImagesUrl: null,
            neoPortalPageEnabled: false,
            groupPhotoRequestInBatch: false,
            termsOfServiceLinkOrgId: null
        };
    }
}
